export class AffiliateAddModel{
    public clientId: number;
    public Affiliates: number[];
}